import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import toast from "react-hot-toast";

const providerConfig = {
  facebook: {
    title: "Facebook Login Settings",
    toggleKey: "enable_facebook",
    fields: [
      { key: "facebook_client_id", label: "Client ID" },
      { key: "facebook_secret_id", label: "Secret Key" },
      { key: "facebook_callback_url", label: "Callback URL" },
    ],
  },
  google: {
    title: "Google Login Settings",
    toggleKey: "enable_google",
    fields: [
      { key: "google_client_id", label: "Client ID" },
      { key: "google_secret_id", label: "Secret Key" },
      { key: "google_callback_url", label: "Callback URL" },
    ],
  },
  apple: {
    title: "Apple Login Settings",
    toggleKey: "enable_apple",
    fields: [
      { key: "apple_client_id", label: "Client ID" },
      { key: "apple_key_id", label: "Key ID" },
      { key: "apple_team_id", label: "Team ID" },
      { key: "apple_scope", label: "Scope" },
      { key: "apple_callback_url", label: "Callback URL" },
    ],
  },
};

export default function SocialProviderSettingsPage() {
  const { provider } = useParams();
  const navigate = useNavigate();

  const config = providerConfig[provider];

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({});

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const res = await api.get("/admin/social/settings");
      setForm(res.data?.data || {});
    } catch (e) {
      toast.error("Failed to load settings");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const onChange = (key, value) =>
    setForm((prev) => ({ ...prev, [key]: value }));

  const onSubmit = async () => {
    try {
      setSaving(true);
      await api.post("/admin/social/settings", form);
      toast.success("Settings updated successfully!");
    //   navigate("/admin/settings/social-login");
    } catch (e) {
      toast.error(e?.response?.data?.message || "Update failed");
    } finally {
      setSaving(false);
    }
  };

  if (!config) return <div className="text-sm">Invalid Provider</div>;
  if (loading) return <div className="text-sm">Loading...</div>;

  return (
    <div className="bg-white rounded-2xl p-6">
      {/* Back Button */}
      <button
        className="text-sm text-blue-600 font-semibold mb-4"
        onClick={() => navigate("/admin/settings-management")}
      >
        ← Back to Providers
      </button>

      <h1 className="text-2xl font-bold">{config.title}</h1>

      {/* Enable Toggle */}
      <div className="mt-6 flex items-center justify-between">
        <div className="text-lg font-semibold">Enable:</div>
        <input
          type="checkbox"
          checked={!!form[config.toggleKey]}
          onChange={(e) => onChange(config.toggleKey, e.target.checked)}
          className="h-5 w-5"
        />
      </div>

      {/* Form Fields */}
      <div className="mt-8 space-y-6">
        {config.fields.map((field) => (
          <div key={field.key}>
            <label className="text-lg font-semibold block mb-2">
              {field.label}
            </label>
            <input
              className="w-full border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-black"
              placeholder={field.label}
              value={form[field.key] || ""}
              onChange={(e) => onChange(field.key, e.target.value)}
            />
          </div>
        ))}
      </div>

      {/* Save Button */}
      <div className="mt-10">
        <button
          type="button"
          onClick={onSubmit}
          disabled={saving}
          className="bg-blue-600 text-white px-6 py-3 rounded-xl font-semibold hover:opacity-90 disabled:opacity-50"
        >
          {saving ? "Updating..." : "Update Settings"}
        </button>
      </div>
    </div>
  );
}
